module.exports = __webpack_public_path__ + "libertad-pack.png";